import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import newStyles from "../styles.module.css"; // Our updated CSS

const ViewDepartmentCard = ({
  companyName,
  adminName,
  adminEmail,
  imageFile,
  id, // admincode
  onDelete,
}) => {
  // Fallbacks if props are empty
  const displayCompanyName = (companyName && companyName.trim()) || "No Title";
  const displayAdminName = (adminName && adminName.trim()) || "No Admin Name";
  const displayAdminEmail = (adminEmail && adminEmail.trim()) || "No Email";

  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true);

  // Construct image URL
  const imageUrl = `https://starbehaviors.com/uploadimage/${imageFile}`;

  // Edit Company -> /view-company/edit/:companycode
  const handleEditCompany = () => {
    navigate(`/company/view-company/edit/${id}`);
  };

  // Toggle enable/disable
  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };
  const handleConfirmDelete = () => {
    setIsEnabled((prev) => !prev);
    if (onDelete) onDelete(id);
    setShowDeleteModal(false);
  };

  // Image click -> store data in localStorage -> go to /admin/view-company/:admincode
  const handleImageClick = () => {
    localStorage.setItem("clickedCompanyName", displayCompanyName);
    localStorage.setItem("clickedImageFile", imageFile);
    navigate(`/company/view-company/${id}`);
  };

  return (
    <div className={newStyles.companyCard}>
      {/* Clickable image */}
      <img
        src={imageUrl}
        alt={displayCompanyName}
        className={newStyles.companyCardImage}
       
        style={{ cursor: "pointer" }}
      />
      <h3 className={newStyles.companyCardTitle}>{displayCompanyName}</h3>
      <p className={newStyles.companyCardText}>
        <strong>Admin:</strong> {displayAdminName}
      </p>
      <p className={newStyles.companyCardText}>
        <strong>Email:</strong> {displayAdminEmail}
      </p>

      <div className={newStyles.companyCardActions}>
        {/* Edit Company Button */}
       
       

        {/* Enable/Disable Company Button */}
        <button
          onClick={handleImageClick}
          className={newStyles.companyCardEditButton}
        >
          Add/View department
        </button>
      </div>

      {/* Enable/Disable Confirmation Modal */}
      {showDeleteModal && (
        <div className={newStyles.deleteModalOverlay}>
          <div className={newStyles.deleteModalContent}>
            <h3>{isEnabled ? "Disable Company" : "Enable Company"}</h3>
            <p>
              Are you sure you want to {isEnabled ? "disable" : "enable"}{" "}
              <b>{displayCompanyName}</b>?
            </p>
            <div className={newStyles.deleteModalActions}>
              <button onClick={() => setShowDeleteModal(false)}>Cancel</button>
              <button onClick={handleConfirmDelete}>
                {isEnabled ? "Disable" : "Enable"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewDepartmentCard;
